import { CommandGroup, CommandItem } from "@/components/ui/command";

/**
 * Renders one labeled group of results (Students, Parents, Instructors,
 * etc.) inside GlobalSearchDialog. Extracted so the parent dialog doesn't
 * repeat the same CommandGroup/CommandItem markup six times over.
 */
export const SearchResultGroup = ({ heading, icon: Icon, items, renderLabel, onSelectItem }) => {
  if (!items || items.length === 0) return null;
  return (
    <CommandGroup heading={heading}>
      {items.map((item) => (
        <CommandItem key={item.id} onSelect={() => onSelectItem(item)} data-testid="global-search-result-item">
          <Icon className="h-4 w-4 mr-2" /> {renderLabel(item)}
        </CommandItem>
      ))}
    </CommandGroup>
  );
};
